import * as R from "ramda";
import { AnimatedSpriteWrap } from "./pixi/animatedSprite";
export function animation(pixiContext, sheets, fileName) {
    console.log("before call animationTextures");
    console.log(sheets);
    console.log(fileName);
    const textures = animationTextures(sheets, fileName);
    console.log("textures", textures);
    return new AnimatedSpriteWrap(pixiContext, textures);
}
export function animationTextures(sheets, fileName) {
    let textures = [];
    console.log("filename", fileName);
    let textureNames = [];
    for (const sheet of sheets) {
        if (sheet.hasAnimation(fileName)) {
            textureNames = textureNames.concat(sheet.animationTextureNames(fileName));
        }
    }
    console.log("textureNames", textureNames);
    for (const sheet of sheets) {
        textures = textures.concat(sheet.texturesWithName(textureNames));
    }
    console.log("textures", textures);
    const sorted = R.sortBy((x) => x[0], textures);
    return R.map(([, texture]) => texture, sorted);
}
export function sprite(sheets, fileName) {
    const sprites = R.chain((sheet) => sheet.sprites([fileName]), sheets);
    return sprites[0];
}
export const Sheets = {
    animation,
    animationTextures,
    sprite,
};
//# sourceMappingURL=sheets.js.map